import styled from 'styled-components';

export const Error = styled.div`
  font-size: ${props => props.big ? "18px" : "14px"};
  color: #dd4b39;
  margin-top: 10px;
  @media (max-width: 768px){
    font-size: ${props => props.big ? "14px" : "10px"};
    color: #dd4b39;
  }
`;



// WEBPACK FOOTER //
// ./src/components/errors/index.js